export const MODAL_POSITION = {
    above: 'above',
    bellow: 'bellow',
};
